/** Synced from apps/companion/package.json by scripts/sync-companion-version.mjs. Do not edit by hand. */
export const APP_VERSION = "0.1.58";
